export default "__VITE_ASSET__Crjiic7H__"